import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Row, Button, Alert, Box, Input } from '@intech/web-ui';
import { useHistory } from 'react-router-dom';
import { FuncionarioDados, PlanoVinculadoEntidade, SaldoContribuicoesFaelceEntidade } from '@entidades';
import { FuncionarioService, PlanoService, FichaFinanceiraService } from '@services';
import { Alertanifesto, GrayBox, Checkbox, Title, ToggleBox, WrapRow, AutoColumn, Label } from './styles';

import { Card } from "../Card";
import { LoadingComponent } from '../../../components/LoadingComponent';
import { FaAngleDoubleLeft } from 'react-icons/fa';
import { SimuladorAposentadoriaService } from '../../../services/SimuladorAposentadoriaService';
import { MasterPage } from '../../../components/MasterPage';
import { NumFuncionalidade } from '../../../helpers/BloqueioFuncionalidade';

interface IProps {
  match?: any;
}

export const Resultado: React.FC<IProps> = ({
  match,
  ...props
}) => {
  const history = useHistory();

  const [AlertText, setAlertText] = useState<string>("");

  const [NomeUsuario, setNomeUsuario] = useState<string>("");
  const [IdadeCompleta, setIdadeCompleta] = useState<string>("");
  const [DataAtual, setDataAtual] = useState<string>("");

  const [IdadeAposentadoriaData, setIdadeAposentadoriaData] = useState<string>("");
  const [IdadeAposentadoriaCompleta, setIdadeAposentadoriaCompleta] = useState<string>("");
  const [IdadeAposentadoria, setIdadeAposentadoria] = useState<number>(match.params.idadeAposentadoria);
  const [Rentabilidade, setRentabilidade] = useState<number>(match.params.rentabilidadeAnual);
  const [MesesPrazo, setMesesPrazo] = useState<number>(match.params.mesesPrazo);
  const [Percentual, setPercentual] = useState<number>(match.params.percentualResgate);
  const [Contribuicao, setContribuicao] = useState<number>(Number.parseFloat(match.params.contribuicaoAdicional.replace(/\./g, "").replace(/\,/g, ".")));

  const [AtivoCD, setAtivoCD] = useState<boolean>(false);
  const [Plano, setPlano] = useState<PlanoVinculadoEntidade>();

  const [FatorAtuarialAT83, setFatorAtuarialAT83] = useState<number>(0);
  const [FatorAtuarialPrazoCerto, setFatorAtuarialPrazoCerto] = useState<number>(0);
  const [Saldo, setSaldo] = useState<number>(0);

  useEffect(() => {
    (async () => {
      try {
        const Planos = await PlanoService.Buscar();

        const PlanoCD = Planos.find((x => (
          x.CD_PLANO === "0002" && (
            x.CD_CATEGORIA === "1" ||
            x.CD_CATEGORIA === "3" ||
            x.CD_CATEGORIA === "5" ||
            (x.CD_CATEGORIA === "6" && (
              x.CD_SIT_PLANO === "28" ||
              x.CD_SIT_PLANO === "29" ||
              x.CD_SIT_PLANO === "30"
            ))
          )
        )));

        if (PlanoCD !== undefined) {
          const dados = await FuncionarioService.Buscar();

          const idadeAposentadoria = await SimuladorAposentadoriaService.BuscarIdadeAposentadoria(IdadeAposentadoria);
          setIdadeAposentadoriaData(moment(idadeAposentadoria.DataAposentadoria, "DD/MM/YYYY").format("DD/MM/YYYY"));
          setIdadeAposentadoriaCompleta(idadeAposentadoria.Idade);

          setNomeUsuario(dados.Entidade.NOME_ENTID);

          const IdadeCompleta = await FuncionarioService.BuscarIdadeCompleta();
          setIdadeCompleta(IdadeCompleta);

          setDataAtual(moment().format("DD/MM/YYYY"));

          const FatorAtuarialAT83 = await SimuladorAposentadoriaService.BuscarFatorAtuarialAT83(IdadeAposentadoria, Rentabilidade);

          setFatorAtuarialAT83(FatorAtuarialAT83);

          const FatorAtuarialPrazoCerto = await SimuladorAposentadoriaService.BuscarFatorAtuarialPrazoCerto(MesesPrazo, Rentabilidade);

          setFatorAtuarialPrazoCerto(FatorAtuarialPrazoCerto);

          const Saldo = await SimuladorAposentadoriaService.CalcularSaldoAposentadoria(PlanoCD.CD_PLANO, IdadeAposentadoria, Rentabilidade, Contribuicao);

          setSaldo(Saldo);

          setAtivoCD(true);
        }

        setPlano(PlanoCD || new PlanoVinculadoEntidade());
      }
      catch (err) {
        if (err.message.indexOf("401") > -1) {
          history.push("/login");
        }
        const error = err.response ? err.response.data : err;
        setAlertText(error || "Erro ao carregar o simulador, tente novamente mais tarde.");
      }
    })();
  }, []);

  function ToMoney(Valor: number) {
    return (
      Valor.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    );
  }

  function renderSimuladorAposentadoria() {
    if (Plano !== undefined) {
      if (AtivoCD) {
        return (
          <MasterPage Funcionalidade={NumFuncionalidade.SIMULADOR_APOSENTADORIA} {...props}>
            <div>
              <Title>{"Resultado da Simulação"}</Title>

              <GrayBox title={`Olá, ${NomeUsuario}! De acordo com os parâmetros informados, esse é o resultado da sua simulação:`}>
                <div>
                  <WrapRow>
                    <AutoColumn>
                      <Card titulo={"Plano"}>
                        {Plano.DS_PLANO}
                      </Card>
                    </AutoColumn>
                  </WrapRow>

                  <WrapRow>
                    <AutoColumn>
                      <Card titulo={"Data da Simulação"}>
                        {DataAtual}
                      </Card>
                    </AutoColumn>

                    <AutoColumn>
                      <Card titulo={"Idade Atual"}>
                        {IdadeCompleta}
                      </Card>
                    </AutoColumn>
                  </WrapRow>

                  <WrapRow>
                    <AutoColumn>
                      <Card titulo={"Data da Aposentadoria"}>
                        {IdadeAposentadoriaData}
                      </Card>
                    </AutoColumn>

                    <AutoColumn>
                      <Card titulo={"Idade na Aposentadoria"}>
                        {IdadeAposentadoriaCompleta}
                      </Card>
                    </AutoColumn>
                  </WrapRow>

                  <WrapRow>
                    <AutoColumn>
                      <Card titulo={"Provisão Matemática Programada (Projetada) (3)"}>
                        R$ {ToMoney(Saldo)}
                      </Card>
                    </AutoColumn>
                  </WrapRow>

                  <WrapRow>
                    <AutoColumn>
                      <Card titulo={`Saque à vista de ${Percentual}% do Saldo Projetado Acumulado`}>
                        R$ {ToMoney(Saldo * (Percentual / 100))}
                      </Card>
                    </AutoColumn>
                  </WrapRow>

                  <WrapRow>
                    <AutoColumn>
                      <Card titulo={`Benefício Inicial por Prazo Certo (${MesesPrazo} Meses) (1)`}>
                        R$ {ToMoney((Saldo - (Saldo * (Percentual / 100))) / FatorAtuarialPrazoCerto)}
                      </Card>
                    </AutoColumn>
                  </WrapRow>

                  <WrapRow>
                    <AutoColumn>
                      <Card titulo={"Benefício Inicial Renda Anualmente Ajustável (2)"}>
                        R$ {ToMoney((Saldo - (Saldo * (Percentual / 100))) / FatorAtuarialAT83)}
                      </Card>
                    </AutoColumn>
                  </WrapRow>

                  <div className={"alert alert-info"}>
                    {"(1) Renda Mensal por Prazo Certo, calculada na data de concessão, a partir do saldo registrado na Provisão Matemática de Benefício Concedido do Participante, a ser paga pelo prazo de “n” meses, podendo “n”, a critério do participante, ser definido entre o mínimo de 120 (cento e vinte) e o máximo de 600 (seiscentos) meses, sendo o valor da renda mensal inicial estabelecida de acordo com a Nota Técnica Atuarial do Plano, e o valor a ser pago a cada novo mês será igual ao valor pago no mês anterior, atualizado pelo valor da cota prevista art. 42, vezes o fator de ajuste."}
                    <br /><br />
                    {"(2) Renda Mensal Anualmente Ajustável, calculada atuarialmente na data de concessão, a partir do saldo registrado na Provisão Matemática de Benefício Concedido do Participante, da sua idade e da expectativa de sua sobrevivência, com base em Tábua de Mortalidade e de taxa de juros real, estabelecidas de acordo com a Nota Técnica Atuarial do Plano e recalculada atuarialmente, após a concessão, no mês de novembro de cada ano;"}
                    <br /><br />
                    {`(3) Esta simulação foi efetuada estimando uma rentabilidade de ${Rentabilidade}% ao ano durante a acumulação e após a concessão do benefício.`}
                    <br /><br />
                    {"(4) Todos os valores desta simulação foram apurados considerando as informações por você fornecidas, exceto o saldo existentes nas Subcontas Participante e Patrocinador. As rentabilidades e benefícios projetados são unicamente referências, não constituindo nenhuma garantia por parte da FAELCE."}
                  </div>

                  {AlertText !== "" && <Alert type={"danger"}>
                    {AlertText}
                  </Alert>}

                  <Button
                    onClick={() => history.push("/simuladorAposentadoria")}
                    icon={<FaAngleDoubleLeft />}
                    type={"primary"}
                    title={"Nova Simulação"}
                    block
                  />

                </div>
              </GrayBox>
            </div>
          </MasterPage>
        );
      }

      return (
        <MasterPage Funcionalidade={NumFuncionalidade.SIMULADOR_APOSENTADORIA} {...props}>
          <WrapRow>
            <Alert type={"info"}>{"Simulador de Aposentadoria disponível apenas para participantes ATIVOS do Plano CD."}</Alert>
          </WrapRow>
        </MasterPage>
      );
    }

    if (AlertText !== "") {
      return (
        <MasterPage Funcionalidade={NumFuncionalidade.SIMULADOR_APOSENTADORIA} {...props}>
          <WrapRow>
            <Alert type={"danger"}>
              {AlertText}
            </Alert>
          </WrapRow>
        </MasterPage>
      );
    }

    return (
      <MasterPage Funcionalidade={NumFuncionalidade.SIMULADOR_APOSENTADORIA} {...props}>
        <WrapRow>
          <LoadingComponent />
        </WrapRow>
      </MasterPage>
    );
  }

  return renderSimuladorAposentadoria();
}
